export default __webpack_public_path__ + "b8986666c873a0ddffaafd7726403c8decd033af946f6763cab170698413590a.svg";